/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddPromotionCustomersRequest
 */
export interface AddPromotionCustomersRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddPromotionCustomersRequest
     */
    customerIds: Array<string>;
}

/**
 * Check if a given object implements the AddPromotionCustomersRequest interface.
 */
export function instanceOfAddPromotionCustomersRequest(value: object): value is AddPromotionCustomersRequest {
    if (!('customerIds' in value) || value['customerIds'] === undefined) return false;
    return true;
}

export function AddPromotionCustomersRequestFromJSON(json: any): AddPromotionCustomersRequest {
    return AddPromotionCustomersRequestFromJSONTyped(json, false);
}

export function AddPromotionCustomersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddPromotionCustomersRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'customerIds': json['customerIds'],
    };
}

export function AddPromotionCustomersRequestToJSON(json: any): AddPromotionCustomersRequest {
    return AddPromotionCustomersRequestToJSONTyped(json, false);
}

export function AddPromotionCustomersRequestToJSONTyped(value?: AddPromotionCustomersRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'customerIds': value['customerIds'],
    };
}

